import React from 'react';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';

import { Locales, messageToString, Sizes } from '@ratehub/base-ui';

import Paths from '../definitions/Paths';
import HeroTabContentListItemContainer from './HeroTabContentListItemContainer';


function HeroTabContentBanking() {
    const intl = useIntl();

    return (
        <Container className="rh-display-grid rh-gap-1">
            {/* Column 1 */}
            <div className="image-wrapper rh-position-relative rh-overflow-hidden rh-width-100p rh-height-100p">
                <img
                    // Placeholder image until we have a proper design
                    src="https://media.istockphoto.com/id/2201346322/photo/happy-family-paying-bills-at-home.jpg?s=2048x2048&w=is&k=20&c=lRFl8yVm8XR3XddIoIoejVhIT86dsL6QfkpcdXMVpic="
                    alt={messageToString(
                        <FormattedMessage
                            id="web-components.HeroTabContentBanking.img.alt"
                            defaultMessage="Happy family paying bills at home"
                        />,
                        intl,
                    )}
                    className="rh-position-absolute rh-width-100p rh-height-100p"
                />
            </div>

            {/* Column 2 */}
            <div className="rh-box-shadow-surround rh-p-1 rh-border-radius-3px rh-display-flex rh-flex-direction-column rh-gap-1">
                <h2 className="rh-text-align-center rh-fg-blueberry-dark weight-medium rh-m-0">
                    <FormattedMessage
                        id="web-components.HeroTabContentBanking.title"
                        defaultMessage="Compare best banking options"
                    />
                </h2>
                <HeroTabContentListItemContainer
                    listItems={listItems}
                />
            </div>
        </Container>
    );
}

const Container = styled.div`
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-template-rows: auto;

    > .image-wrapper {
        min-height: 15rem;

        > img {
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            object-fit: cover;
            border-radius: 0 ${Sizes.SPACING.FOUR};
        }
    }
`;

const listItems = [
    {
        iconKey: 'person',
        title: (
            <FormattedMessage
                id="web-components.HeroTabContentBanking.listItems.personalChequing.title"
                defaultMessage="Personal chequing"
            />
        ),
        subtitle: (
            <FormattedMessage
                id="web-components.HeroTabContentBanking.listItems.personalChequing.subtitle"
                defaultMessage="Find low fee banking options"
            />
        ),
        href: {
            [Locales.ENGLISH]: Paths.PERSONAL_CHEQUING_EN,
            [Locales.FRENCH]: Paths.PERSONAL_CHEQUING_FR,
        },
    },
    {
        iconKey: 'briefcase',
        title: (
            <FormattedMessage
                id="web-components.HeroTabContentBanking.listItems.businessChequing.title"
                defaultMessage="Business chequing"
            />
        ),
        subtitle: (
            <FormattedMessage
                id="web-components.HeroTabContentBanking.listItems.businessChequing.subtitle"
                defaultMessage="Manage daily business spending"
            />
        ),
        href: {
            [Locales.ENGLISH]: Paths.BUSINESS_CHEQUING_EN,
            [Locales.FRENCH]: Paths.BUSINESS_CHEQUING_FR,
        },
    },
    {
        iconKey: 'dollar-up',
        title: (
            <FormattedMessage
                id="web-components.HeroTabContentBanking.listItems.highInterestSavings.title"
                defaultMessage="High interest savings accounts"
            />
        ),
        subtitle: (
            <FormattedMessage
                id="web-components.HeroTabContentBanking.listItems.highInterestSavings.subtitle"
                defaultMessage="Rates as high as 2.80%"
            />
        ),
        href: {
            [Locales.ENGLISH]: Paths.HIGH_INTEREST_SAVINGS_EN,
            [Locales.FRENCH]: Paths.HIGH_INTEREST_SAVINGS_FR,
        },
    },
];

export default HeroTabContentBanking;
